import { IGptConfiguration } from '../../EnterpriseGPTApi/EnterpriseGPTApiV1Client';
import { GptConfigurationsAction } from '../actions/gptConfigurationsAction';

export const gptConfigurationsReducer = (gptConfigurations: IGptConfiguration[], action: GptConfigurationsAction): IGptConfiguration[] => {
    switch (action.type) {
        case 'SET_GPT_CONFIGURATIONS':
            return [...action.payload];
        case 'ADD_GPT_CONFIGURATION':
            return [...gptConfigurations, action.payload];
        case 'DELETE_GPT_CONFIGURATION':
            return gptConfigurations.filter(x => x.id !== action.payload);
        case 'EDIT_GPT_CONFIGURATION':
            return gptConfigurations.map(x => x.id === action.payload.id ? action.payload : x);
        case 'EDIT_GPT_CONFIGURATIONS':
            return gptConfigurations.map(x => action.payload.some(y => y.id === x.id) ? action.payload.find(y => y.id === x.id)! : x);
        default:
            return gptConfigurations;
    }
};
